import React from 'react';
import { blockFonts, getCustomFontSize } from 'venn-state';
import { REPORT_LAB_FONT_BODY } from 'venn-ui-kit';
import { useRecoilValue } from 'recoil';
import { useBlockId } from '../../../contexts/BlockIdContext';
import { useIsCorrelationLabelFull } from '../../../logic/useCorrelationLabelDisplay';
import { cn } from '@/lib/utils';

const VerticalHeader: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const blockId = useBlockId();
  const tableFont = useRecoilValue(blockFonts.blockTableData(blockId));
  const isFullLabelDisplay = useIsCorrelationLabelFull();
  const fontSize = getCustomFontSize(tableFont);

  return (
    <div className="w-full">
      <div
        className="w-full h-full flex content-center items-center justify-center"
        style={{ fontSize: fontSize ?? REPORT_LAB_FONT_BODY }}
      >
        <div
          className={cn([
            'overflow-hidden text-ellipsis h-[105px] p-0 m-0 [writing-mode:sideways-lr]',
            isFullLabelDisplay ? 'whitespace-normal break-words line-clamp-[unset]' : 'whitespace-nowrap line-clamp-1',
          ])}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default VerticalHeader;
